module.exports = __webpack_public_path__ + "img/emo_40.ec1a242e.png";